import React, { useContext, useState, useMemo } from 'react';
import { useQuery } from 'react-query';
import { Main } from '../../NecttosComp/Layout/Layout';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import { NecttosContext } from '../../context/NecttosContext';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';
import toast from 'react-hot-toast';
import AdmissionVerificationProcess from './AdmissionVerificationProcess';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import Instruction from '../../Documentation/Instruction';
import { Grid } from 'react-loader-spinner';
import DeleteVerificationProcess from './DeleteVerificationProcess';
import notFoundProfile from '../../static/images/library/noPhotoAvailable.png'
import AddNewUsertoAdmission from './AddNewUsertoAdmission';


const getAdmissionControlCentre = (collegeId, classId, userId, key, startDate, endingDate, newClassId) => async () => {
  const instance = await getAxiosTokenInstance();
  try {
    const resp = await instance.get('/college/admissionProcess2/getAdmissionControlCentre', {
      params: {
        collegeId,
        classId,
        userId,
        key,
        startDate,
        endingDate,
        newClassId,
      },
    });
    if (resp.data.statusCode === 400) {
      throw new Error(resp.data.message || 'API Error');
    } else {
      return resp?.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message || error.message || 'API Error');
  }
};


const getrejectUserFromVerification = async () => {
  const instance = await getAxiosTokenInstance();
  try {
    const resp = await instance.get('/college/admissionProcess2/getrejectUserFromVerification');
    if (resp.data.statusCode === 400) {
      throw new Error(resp.data.message || 'API Error');
    } else {
      return resp?.data;
    }
  } catch (error) {
    throw new Error(error?.response?.data?.message || error.message || 'API Error');
  }
};




function AdmissionControlCenter({ isTemp, onClose }) {
  const { college, role, collegeId,selectedCollege, userId, profile } = useContext(NecttosContext);
  const [keyData, setKeyData] = useState('department');
  const [searchTerm, setSearchTerm] = useState('');
  const [state, setState] = useState({});
  let classId = '';

  // Fetch admission data
  const { data, refetch, status } = useQuery(
    ['getAdmissionControlCentre', collegeId, classId, userId, role, keyData],
    getAdmissionControlCentre(collegeId, classId, userId, keyData, role)
  );

  const getTimeExtended = async () => {
    const instance = await getAxiosTokenInstance();
    const resp = await instance.get('/college/admissionProcess2/gettimeextended');
    if (resp.data.statusCode === 400) throw new Error(resp.data.message);
    return resp.data;
  }


  // Fetch rejected users data
  const { data: datareject, refetchreject, statusreject } = useQuery(
    ['getrejectUserFromVerification', collegeId, classId, userId, role, keyData],
    getrejectUserFromVerification
  );


  const { data: datagivetime } = useQuery(
    ['getTimeExtended'],
    getTimeExtended
  );

  const userList = keyData === 'rejected'
    ? datareject?.data
    : keyData === 'giveTimed'
      ? datagivetime?.data
      : data?.list || [];

  const filteredUserList = userList?.filter((user) =>
    user?.name?.toLowerCase()?.includes(searchTerm.toLowerCase())
  );

  const verificationStages = selectedCollege?.verificationStages ||[];
  const previousKeyMap = selectedCollege?.previousKeyMap || {};

  
  return (
    <>
      <Main width="100%" height="100%" title="Admission Control Center">
        <div className="h-[80vh]">
          <div className="flex gap-4">
            <div className="fixed left-[1%] w-[15%] z-10">
              <div className="w-full max-h max-w-sm mx-auto bg-slate-100 flex-col dark:bg-gray-800 rounded-xl shadow-md p-1 flex items-center space-x-4 my-3">
                <img
                  src={profile?.photoURL || notFoundProfile}
                  alt="Profile"
                  className="w-18 h-18 rounded-lg object-cover border-2 border-green-500"
                />
                <div className="flex-1">
                  <h2 className="text-lg text-center font-semibold text-gray-900 dark:text-white">
                    {profile?.name}
                  </h2>
                  <p className="text-sm text-center text-gray-600 dark:text-gray-300">Department of Maths</p>
                </div>
              </div>
              <div className="rounded-xl shadow-lg overflow-hidden border border-slate-200 dark:border-slate-700 dark:bg-slate-800">
                <div className="bg-gradient-to-r from-blue-700 to-indigo-800 text-white text-center font-bold py-3 px-3 text-sm uppercase tracking-wide">
                  Admission Workflow
                </div>
                <div className="flex flex-col divide-y divide-gray-200 dark:divide-slate-700">
                  {verificationStages?.map(
                    (stage) =>
                     (
                        <div
                          key={stage.keyName}
                          onClick={() => setKeyData(stage.keyData)}
                          className={`text-sm px-4 py-2 cursor-pointer transition-all duration-200 font-medium ${stage.keyData === keyData
                            ? 'bg-blue-600 text-white'
                            : 'text-gray-700 dark:text-slate-200 hover:bg-blue-100 dark:hover:bg-slate-700'
                            }`}
                        >
                          {stage.title}
                        </div>
                    )
                  )}
                </div>
              </div>
            </div>

            <div className="fixed ml-[15%] w-[84%] px-4 overflow-hidden h-[96vh]">
              <div className="flex items-center justify-between w-full px-4 py-2">
                <div className="flex items-center gap-2"></div>
                <div className="flex items-center">
                  <Input2
                    className="w-[40vw]"
                    type="text"
                    fieldName="search"
                    placeholder="Search students..."
                    setState={setSearchTerm}
                    state={searchTerm}
                    searchKey="name"
                  />
                  <Instruction keyId={'admissionControlCenter'} />
                  <Button type="save"  onClick={() =>
                                  setState({
                                    ...state,
                                    addNewUsertoAdmission: true,
                                 //add profile id here 
                                  })
                                }>
                    Add User
                  </Button>
                  <Button type="close" onClick={onClose}>
                    Close
                  </Button>
                </div>
              </div>

              <Table height="100%" width="100%" className="rounded-lg shadow-md overflow-hidden">
                <Thead>
                  <Tr className="bg-gray-100 fixed">
                    <Th width="10%" className="py-3 px-4">
                      Application Status/Token
                    </Th>
                    <Th width="10%" className="py-3 px-4">
                      Created/Previous Time
                    </Th>
                    <Th width="10%" className="py-3 px-4">
                      Name
                    </Th>
                    <Th width="10%" className="py-3 px-4">
                      Mobile
                    </Th>
                    <Th width="10%" className="py-3 px-4">
                      {keyData === 'rejected' ? 'Delete' : 'Course'}
                    </Th>
                    <Th width="10%" className="py-3 px-4">
                      Verification
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {status === 'loading' ? (
                    <div className="m-5 p-5 flex justify-center items-center">
                      <Grid height={'250'} width="250" color="#0083f5" visible={status === 'loading'} />
                    </div>
                  ) : (
                    <div className="overflow-scroll h-[80vh]">
                      {filteredUserList?.length === 0 ? (
                        <div className="m-5 p-6 flex justify-center items-center bg-green-50 dark:bg-green-900 border border-green-300 dark:border-green-700 rounded-xl shadow-sm">
                          <div className="text-center">
                            <svg
                              className="mx-auto mb-3 h-8 w-8 text-green-600 dark:text-green-300"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M5 13l4 4L19 7"
                              />
                            </svg>
                            <h2 className="text-lg font-semibold text-green-700 dark:text-green-200">
                              All Admissions Verified
                            </h2>
                            <p className="text-sm text-green-600 dark:text-green-300">
                              There are no pending verifications. Everything is up to date. Just refresh to ensure
                            </p>
                          </div>
                        </div>
                      ) : (
                        filteredUserList?.map((user) => (
                          <Tr key={user.id || user._id} className="hover:bg-gray-50 border-b border-gray-200">
                            <Td width="10%" className="py-3 px-4">
                              {keyData === 'department' ? `${user.percentageOfCompletion || 0}%` : user.activeStatus}
                            </Td>
                            <Td width="10%" className="py-3 px-4">
                              {new Date(user.createdOn).toDateString()}
                            </Td>
                            <Td width="10%" className="py-3 px-4 font-medium">
                              {user.name}
                            </Td>
                            <Td width="10%" className="py-3 px-4">
                              {user.phoneNumber}
                            </Td>
                            <Td width="10%" className="py-3 px-4">
                              {keyData === 'rejected' ? (
                                <Button
                                  type='delete'
                                  onClick={() => {
                                    setState({
                                      ...state,
                                      deleteVerificationProcess: true,
                                      studentId: user.id || user._id,
                                    });
                                  }}
                                  className="btn btn-danger"
                                >
                                  Delete
                                </Button>
                              ) : (
                                `${user.shortName}`
                              )}


                            </Td>
                            <Td width="10%" className="py-3 px-4">
                              <Button
                                type="save"
                                onClick={() =>
                                  setState({
                                    ...state,
                                    verificationProcess: true,
                                    studentId: user.id || user._id,
                                    isTemp: user.isTemp || false,
                                  })
                                }
                              >
                                Start Procedure
                              </Button>
                            </Td>
                          </Tr>
                        ))
                      )}
                    </div>
                  )}
                </Tbody>
              </Table>
            </div>
          </div>
        </div>
      </Main>

      {state.verificationProcess && (
        <AdmissionVerificationProcess
          userId={state.studentId}
          isStudent={true}
          keyData={keyData}
          refectData={refetch}
          previousKeyMap={previousKeyMap}
          stateData={state}
          setStateData={setState}
          toast={toast}
          onClose={() => setState({ ...state, verificationProcess: false })}
        />
      )}

      {state.addNewUsertoAdmission && (
        <AddNewUsertoAdmission
          onClose={() => setState({ ...state, addNewUsertoAdmission: false })}
        />
      )}

      {state.deleteVerificationProcess && (
        <DeleteVerificationProcess
          userId={state.studentId}
          isStudent={true}
          keyData={keyData}
          refectData={refetch}
          stateData={state}
          setStateData={setState}
          toast={toast}
          onClose={() => setState({ ...state, deleteVerificationProcess: false })}
        />
      )}
    </>
  );
}

export default AdmissionControlCenter;
